import { render, staticRenderFns } from "./HasDisabledAccess.vue?vue&type=template&id=73b5eae7&"
import script from "./HasDisabledAccess.vue?vue&type=script&lang=ts&"
export * from "./HasDisabledAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports